export default {
  path: '/capabilityManage',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'capabilityManage',
  component: () => import('./index')
};
